import { action } from 'typesafe-actions';
import { IChartPickerSelection } from '../reducers/chart_picker';

const entity = 'chart_picker';

const UPDATE_CHART_LAYOUT = `${entity}/UPDATE`;

const actionUpdateChartPicker = (mode: IChartPickerSelection) =>
  action(UPDATE_CHART_LAYOUT, mode);

export {
  UPDATE_CHART_LAYOUT,
  actionUpdateChartPicker
};